import * as React from "react";
import styled from "styled-components";

import { Header, Image, NavItem, Text } from "../../../../components/atoms";
import { ILoginUser } from "../../../../services/api/customer";
import { dateFromIso } from "../../../../utils/index";
import { MessageTemplate } from "../../../../services/api/checkout";

interface IProps {
  address: string;
  categoryImage: string;
  date: string;
  id?: string;
  payment: string;
  therapist: string;
  treatments: string[];
  totalAmount: number;
  bookingMessage: MessageTemplate;
  user: ILoginUser;
}

const BookingConfirmationBlock = styled.div`
  margin-bottom: 10px;

  * {
    line-height: 1.8;
  }
`;

const BookingConfirmationImage = Image.extend`
  max-width: 100px;
  max-height: 100px;
  margin-bottom: 10px;
`;

const BookingConfirmationWrapper = styled.div``;

const BookingConfirmation: React.FC<IProps> = (props) => {
  const mapTreatments = props.treatments.map((treatment, index) => {
    return (
      <Text size="16" color="grey" key={index}>
        {treatment}
      </Text>
    );
  });

  const renderMessage = (bookingMessage: MessageTemplate) => {
    return bookingMessage.message.map((message, index) => {
      return (
        <Text size="18" color="grey" key={index}>
          {message}
        </Text>
      );
    });
  };

  return (
    <BookingConfirmationWrapper>
      <BookingConfirmationBlock>
        <BookingConfirmationImage src={props.categoryImage} />
        <Header>{props.bookingMessage.title}</Header>
      </BookingConfirmationBlock>
      <BookingConfirmationBlock>
        {renderMessage(props.bookingMessage)}
      </BookingConfirmationBlock>
      <BookingConfirmationBlock>
        <Text size="20" color="grey">
          {props.therapist}{" "}
          {dateFromIso(props.date).toFormat("cccc LLLL dd - h:mm a")}
        </Text>
      </BookingConfirmationBlock>
      <BookingConfirmationBlock>
        <Text size="16" weight="semibold" color="grey">
          Treatments:
        </Text>
        {mapTreatments}
      </BookingConfirmationBlock>
      <BookingConfirmationBlock>
        <Text size="16" weight="semibold" color="grey">
          Address:
        </Text>
        <Text size="16" color="grey">
          {props.address}
        </Text>
      </BookingConfirmationBlock>
      {props.payment && (
        <BookingConfirmationBlock>
          <Text size="16" weight="bold" color="grey">
            Payment:
          </Text>
          <Text size="16" color="grey">
            {props.payment}
          </Text>
        </BookingConfirmationBlock>
      )}
      <BookingConfirmationBlock>
        <Text size="16" weight="bold" color="grey">
          Questions or issues?
        </Text>
        <Text size="16" color="grey">
          Contact the Ruuby Team{" "}
          <NavItem href="tel:+4402074608319">02074608319</NavItem>
        </Text>
        <NavItem type="link" href="mailto:concierge@ruuby.com">
          concierge@ruuby.com
        </NavItem>
      </BookingConfirmationBlock>
      <BookingConfirmationBlock>
        <NavItem type="block" to="/account">
          Check status
        </NavItem>
      </BookingConfirmationBlock>
    </BookingConfirmationWrapper>
  );
};

export { BookingConfirmation };
